import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BecomeVisibleModule } from '@fi-shared/fi-directives/become-visible/become-visible.module';
import { FiWhenScrolledModule } from '@fi-shared/fi-directives/when-scrolled/when-scrolled.module';
import { FiAutofocusModule } from '@fi-shared/fi-directives/autofocus/autofocus.module';
import { FiAutoscrollOnDragModule } from '@fi-shared/fi-directives/fi-autoscroll-on-drag/fi-autoscroll-on-drag.module';
import { FiBindHtmlCompileModule } from '@fi-shared/fi-directives/bind-html-compile/bind-html-compile.module';
import { FiLineClampModule } from '@fi-shared/fi-directives/fi-line-clamp/fi-line-clamp.module';
import { FiSwipeModule } from '@fi-shared/fi-directives/fi-swipe/fi-swipe.module';
import { FiValidatingFormModule } from '@fi-shared/fi-directives/fi-validating-form/fi-validating-form.module';
import { FiInputKeyboardNavigationModule } from '@fi-shared/fi-directives/input-keyboard-navigation';
import { ToggleDropdownModule } from '@fi-shared/fi-directives/toggle-dropdown';
import { FiDropHandlerDirective } from './fi-drop-handler.directive';
import { FiElementFocusedModule } from '@fi-shared/fi-directives/fi-element-focused/fi-element-focused.module';
import { FiLongPressMobileModule } from '@fi-shared/fi-directives/fi-long-press/fi-long-press-mobile.module';
import { FiComponentOutletModule } from '@fi-shared/fi-directives/fi-component-outlet/fi-component-outlet.module';
import { FiCustomValidatorsModule } from '@fi-shared/fi-directives/fi-custom-validators/fi-custom-validators.module';
import { FiCdkNoDragModule } from '@fi-shared/fi-directives/fi-cdk-no-drag/fi-cdk-no-drag.module';
import { FiCustomInputValidatorModule } from '@fi-shared/fi-directives/fi-custom-input-validator/fi-custom-input-validator.module';
import { AutosizeDirective } from '@fi-shared/fi-directives/autosize.directive';
import { ImagePreviewClickDirective } from '@fi-shared/fi-directives/image-preview-click.directive';
import { FileDropDirective } from '@fi-shared/fi-directives/file-drop.directive';
import { FadeTextDirective } from '@fi-shared/fi-directives/fade-text.directive';
import { RequiredIfValidatorDirective } from '@fi-shared/fi-directives/requiredif-validator.directive';
import { FitImageDirective } from '@fi-shared/fi-directives/fit-image.directive';
import { NgInitDirective } from '@fi-shared/fi-directives/ng-init.directive';
import { FiInputMaskModule } from '@fi-shared/fi-directives/fi-input-mask/fi-input-mask.module';
import { FiMeasureLabelDirective } from './measure-label.directive';
import { FiInputAutoWidthModule } from './fi-input-auto-width/fi-input-auto-width.module';
import { FiCheckboxClickAreaModule } from './fi-chekbox-click-area/fi-checkbox-click-area.module';
import { FiDragScrollModule } from './fi-drag-scroll/fi-drag-scroll.module';

@NgModule({
    imports: [
        CommonModule,
        BecomeVisibleModule,
        FiWhenScrolledModule,
        FiAutofocusModule,
        FiAutoscrollOnDragModule,
        FiBindHtmlCompileModule,
        FiLineClampModule,
        FiSwipeModule,
        FiValidatingFormModule,
        FiInputKeyboardNavigationModule,
        ToggleDropdownModule,
        FiElementFocusedModule,
        FiLongPressMobileModule,
        FiComponentOutletModule,
        FiCdkNoDragModule,
        FiCustomValidatorsModule,
        FiCustomInputValidatorModule,
        FiInputMaskModule,
        FiInputAutoWidthModule,
        FiCheckboxClickAreaModule,
        FiDragScrollModule,
    ],
    declarations: [
        FiDropHandlerDirective,
        FiMeasureLabelDirective,
        AutosizeDirective,
        ImagePreviewClickDirective,
        FileDropDirective,
        FadeTextDirective,
        RequiredIfValidatorDirective,
        FitImageDirective,
        NgInitDirective,
    ],
    exports: [
        BecomeVisibleModule,
        FiWhenScrolledModule,
        FiAutofocusModule,
        FiAutoscrollOnDragModule,
        FiBindHtmlCompileModule,
        FiLineClampModule,
        FiSwipeModule,
        FiValidatingFormModule,
        FiInputKeyboardNavigationModule,
        ToggleDropdownModule,
        FiDropHandlerDirective,
        FiElementFocusedModule,
        FiLongPressMobileModule,
        FiCdkNoDragModule,
        FiCustomValidatorsModule,
        FiCustomInputValidatorModule,
        AutosizeDirective,
        ImagePreviewClickDirective,
        FileDropDirective,
        FadeTextDirective,
        RequiredIfValidatorDirective,
        FitImageDirective,
        NgInitDirective,
        FiInputMaskModule,
        FiMeasureLabelDirective,
        FiCheckboxClickAreaModule,
        FiInputAutoWidthModule,
        FiDragScrollModule,
    ],
})
export class FiDirectivesModule {}
